import axios from "axios";
import initializeAxios from "../util/Axios";

class AdsService {
  constructor() {
    initializeAxios();
  }

  async getAds({ pageIndex, pageSize, searchTerm }) {
    const response = await axios.get("/api/ads", {
      params: { pageIndex, pageSize, searchTerm }
    });
    return response.data;
  }

  async addAd({ name, image, url, isActive }) {
    const response = await axios.post("/api/ads/add", {
      name,
      image,
      url,
      isActive
    });
    return response.data;
  }

  async updateAd({ adId, name, image, url, isActive }) {
    const response = await axios.put("/api/ads/update", {
      adId,
      name,
      image,
      url,
      isActive
    });
    return response.data;
  }

  async deleteAd(adId) {
    const response = await axios.put("/api/ads/delete", { adId });
    return response.data;
  }

  async uploadToS3(data) {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post("/api/util/uploadimage", formData);
    return response.data;
  }
}

export default new AdsService();
